import React, { useCallback, useState } from 'react';
import useMeasure from 'react-use-measure';

import { ResizeObserver } from '@juggle/resize-observer';
import { useSpring } from '@react-spring/web';

import { ExpandInfo } from './ExpandInfo';
import * as T from './interfaces';
import { useModalMobileContext } from 'hooks';

export const Container = ({
  children,
  defaultOpen,
  title,
  id,
  description,
  logEvent,
  useHookModalMobileScroll,
  ...rest
}: T.ExpandInfo) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const { handleSetScrollAllTop, modalMode } = useModalMobileContext();

  const [ref, { height: viewHeight }] = useMeasure({
    polyfill: ResizeObserver,
  });
  const { height, opacity, y } = useSpring({
    from: { height: 0, opacity: 0, y: 0 },
    to: {
      height: isOpen ? viewHeight : 0,
      opacity: isOpen ? 1 : 0,
      y: isOpen ? 0 : 20,
    },
  });

  const handleExpand = useCallback(
    (status: boolean) => {
      setIsOpen(oldState => !oldState);

      if (useHookModalMobileScroll && modalMode) handleSetScrollAllTop(!status);
    },
    [setIsOpen],
  );

  return (
    <ExpandInfo
      {...rest}
      id={`expandInfo@${id}`}
      contentStyle={{
        opacity,
        height,
      }}
      verticalInteraction={{ y }}
      containerChildRef={ref}
      title={isOpen ? title.inOpen : title.inClose}
      description={isOpen ? description.inOpen : description.inClose}
      isOpen={isOpen}
      handleExpand={handleExpand}
    >
      {children}
    </ExpandInfo>
  );
};
